import { MessageCircle, X } from 'lucide-react'
import { buildWhatsAppLink } from '@/lib/postgraduate-chat/phone'

interface ChatHeaderProps {
  readonly attendantName: string
  readonly whatsappNumber: string
  readonly closeDisabled?: boolean
  readonly onClose: () => void
}

const DIRECT_WHATSAPP_MESSAGE =
  'Olá! Vim do chat do site e quero falar direto por aqui.'

/**
 * Cabeçalho fixo do painel: nome do atendente da plataforma, status
 * "Online agora", o botão "Fale direto pelo WhatsApp" (RN10 — disponível
 * desde a abertura, antes de qualquer resposta) e o fechar.
 */
export function ChatHeader({
  attendantName,
  whatsappNumber,
  closeDisabled = false,
  onClose,
}: ChatHeaderProps) {
  const whatsappHref = buildWhatsAppLink(whatsappNumber, DIRECT_WHATSAPP_MESSAGE)

  return (
    <div className="flex shrink-0 items-center gap-2.5 bg-primary-900 px-4 py-3.5 text-white">
      <div className="flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white/15 font-rethink font-semibold text-sm">
        {attendantName.charAt(0)}
      </div>

      <div className="min-w-0 flex-1">
        <p className="truncate font-rethink text-[15px] font-semibold leading-tight">
          {attendantName}
        </p>
        <p className="flex items-center gap-1.5 whitespace-nowrap font-rethink text-white/80 text-xs">
          <span
            aria-hidden="true"
            className="inline-block size-1.5 shrink-0 rounded-full bg-green-400"
          />
          Online agora
        </p>
      </div>

      <a
        aria-label="Fale direto pelo WhatsApp"
        className="flex shrink-0 items-center justify-center whitespace-nowrap rounded-full bg-green-500 p-2 font-rethink font-semibold text-white text-xs transition-colors hover:bg-green-600 sm:px-2.5 sm:py-2"
        href={whatsappHref}
        rel="noopener noreferrer"
        target="_blank"
      >
        <MessageCircle className="size-4 sm:hidden" />
        <span className="hidden sm:inline">Fale direto pelo WhatsApp</span>
      </a>

      <button
        aria-label="Fechar chat"
        className="shrink-0 rounded-full p-1.5 text-white/90 transition-colors hover:bg-white/10 hover:text-white disabled:pointer-events-none disabled:opacity-50"
        disabled={closeDisabled}
        onClick={onClose}
        type="button"
      >
        <X className="size-4" />
      </button>
    </div>
  )
}
